// extracted by css-extract-rspack-plugin
export default {"tree":"mti5ULOHHTklHGxF","row":"gU4TPYElVkR3wCzs"};